import {
  DESIGN,
  MOBILE_BREAKPOINT
} from './constants.js';

export function layoutNodes(nodes, width, height) {
  if (width < MOBILE_BREAKPOINT) {
    const top = 38;
    const available = Math.max(height - 88, 120);
    const gap = nodes.length > 1 ? available / (nodes.length - 1) : 0;

    return nodes.map((node, index) => ({
      ...node,
      cx: width / 2,
      cy: top + (index * gap),
      width: Math.min(180, width - 36),
      height: 54
    })).map(addBounds);
  }

  const scaleX = width / DESIGN.width;
  const scaleY = height / DESIGN.height;

  return nodes.map(node => ({
    ...node,
    cx: node.x * scaleX,
    cy: node.y * scaleY,
    width: Math.max(128, Math.min(180, width * 0.18)),
    height: 62
  })).map(addBounds);
}

export function measureCanvas(wrapper, canvas) {
  const rect = wrapper.getBoundingClientRect?.() || {};
  const width = Math.round(rect.width || wrapper.clientWidth || canvas.clientWidth || 0);
  const height = Math.round(rect.height || wrapper.clientHeight || canvas.clientHeight || 0);

  return {
    width: width > 0 ? width : 720,
    height: height > 0 ? height : 260,
    measured: width > 0 && height > 0
  };
}

function addBounds(node) {
  return {
    ...node,
    left: node.cx - (node.width / 2),
    top: node.cy - (node.height / 2)
  };
}
